"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTextAlign = void 0;

var _types = require("../../../../../../types");

var getTextAlign = function getTextAlign(textAlignment) {
  switch (textAlignment) {
    case _types.PkpassTextAlignTypes.PKTextAlignmentLeft:
      return 'left';

    case _types.PkpassTextAlignTypes.PKTextAlignmentCenter:
      return 'center';

    case _types.PkpassTextAlignTypes.PKTextAlignmentRight:
      return 'right';

    case _types.PkpassTextAlignTypes.PKTextAlignmentNatural:
      return undefined;

    default:
      return 'left';
  }
};

exports.getTextAlign = getTextAlign;
//# sourceMappingURL=getTextAlign.js.map